<template>
  <div>
    <div>
      <el-select-ex
        ref="sel"
        v-model="curEditItem.fUserID"
        style="width: 100%"
        url="SystemApplication/Role/NotRoleForUserEntry"
        label-field="fName"
        value-field="fUserID"
        :extra-param="{ fid: fRoleID }"
        sel-first
      />
      <!-- <el-select v-model="curEditItem.director" placeholder="请选择" >
                                    <el-option
                                      v-for="item in porjectData"
                                      :key="item.fid"
                                      :label="item.fName"
                                      :value="item.fid">
                                      <span style="float: left">{{ item.fName }}</span>
                                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fNumber }}</span>
                                    </el-option>
                                  </el-select> -->
    </div>
    <div style="text-align: center">
      <el-button type="warning" size="small" @click="addDirector"
        >添加</el-button
      >
    </div>
    <div>
      <el-table :data="tableData">
        <el-table-column prop="fName" label="用户" />
        <el-table-column prop="fType" label="用户类型" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <ConfirmButton @confirm="delDirector(scope.row)"
                >删除</ConfirmButton
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ConfirmButton from "@components/ConfirmButton";

export default {
  components: {
    ConfirmButton,
  },
  props: {
    fRoleID: Number,
  },
  data: function () {
    return {
      curEditItem: {
        fUserID: "",
      },
      rules: {},
      tableData: [],
    };
  },
  computed: {
    // isEdit: function() {
    //   return !!this.form.fRegionID
    // }
  },
  mounted: function () {
    this.refresh();
  },
  methods: {
    refresh: function () {
      this.$httpPost("SystemApplication/Role/RoleForUserEntry", {
        fid: this.fRoleID,
      }).then((res) => {
        this.tableData = res.datalist;
      });
    },

    addDirector: function () {
      this.$httpPost("SystemApplication/Role/RoleForUserAdd", {
        fRoleID: this.fRoleID,
        fUserID: this.curEditItem.fUserID,
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
          this.$refs.sel.refresh();
          this.curEditItem.fUserID = null;
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },

    delDirector: function (row) {
      //   console.log(row)
      this.$httpPost("SystemApplication/Role/RoleForUserDelete", {
        fRoleID: this.fRoleID,
        fUserID: row.fUserID,
      }).then((res) => {
        //   console.log(res)
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
          this.$refs.sel.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },

    postData: function (type, data) {
      return this.$httpPost(
        `BasicInformation/RegionDirector/RegionForDirector${type}`,
        data
      ).then(async (res) => {
        if (res.isSuccess) {
          this.$message.success(res.message);
          this.refresh();
          this.$refs.sel.refresh();
        } else {
          this.$message.error(res.message);
          throw res.message;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
div {
  margin: 10px 0;
}
</style>
